import styled from 'styled-components';
import { layout, LayoutProps } from 'styled-system';
import { Text } from '~/components/typography';

export const Caption = styled(Text).attrs({
  fontSize: 'small',
})`
  margin-top: 24px;
  color: ${props => props.theme.colors.content.secondary};

  /* hacky fix below to keep caption from overflowing image width */
  width: 0px;
  min-width: 100%;
`;

export const Container = styled.div`
  max-width: 100%;
`;

export const StyledIcon = styled.img`
  margin-right: 8px;
`;

// TODO this is specific to the funnel images
export const Image = styled.img<LayoutProps>`
  border-radius: 4px;
  max-height: 480px;

  ${props => props.theme.media.largeScreenUp} {
    max-height: 600px;
  }

  ${layout}
`;

interface ImageProps extends LayoutProps {
  maxWidth?: string;
}

export const ResponsiveImage = styled.img<ImageProps>`
  border-radius: 4px;
  max-height: 480px;
  max-width: ${props => props.maxWidth};

  ${props => props.theme.media.largeScreenUp} {
    max-height: 600px;
  }

  ${layout}
`;
